<template>
  <div v-if="tagDefs.length" class="intake-tag-bar">
    <span class="intake-tag-bar__label">Tags:</span>
    <TagChips :tags="tags" :tag-defs="tagDefs" />
    <TagPicker :tags="tags" :tag-defs="tagDefs" @update:tags="onTagsChanged" />
  </div>
</template>

<script setup>
import TagChips from "@/components/dashboard/TagChips.vue";
import TagPicker from "@/components/dashboard/TagPicker.vue";
import { intakeService } from "@/services/intakeService";
import { orderInfoService } from "@/services/orderInfoService";

const props = defineProps({
  tags: { type: Array, default: () => [] },
  tagDefs: { type: Array, default: () => [] },
  entityType: { type: String, required: true, validator: (v) => ["document", "order", "submission"].includes(v) },
  entityId: { type: [String, Number], required: true },
});

const emit = defineEmits(["update:tags"]);

async function onTagsChanged(newTags) {
  const oldTags = [...props.tags];
  emit("update:tags", newTags);
  try {
    if (props.entityType === "submission") {
      await orderInfoService.updateSubmissionTags(props.entityId, newTags);
    } else if (props.entityType === "document") {
      await intakeService.updateDocumentTags(props.entityId, newTags);
    } else {
      await intakeService.updateOrderTags(props.entityId, newTags);
    }
  } catch {
    emit("update:tags", oldTags);
  }
}
</script>

<style lang="scss" scoped>
.intake-tag-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
}

.intake-tag-bar__label {
  font-family: "DM Sans", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
}
</style>
